import axiosInstance from "../api/axios";

export const fetchMyPermissions = async () => {
  const response = await axiosInstance.get("/me/permissions");
  return response;
};

export const fetchPermissions = async () => {
  return axiosInstance.get("/permissions");
};

export const fetchRoles = async () => {
  return axiosInstance.get("/roles");
};

export const createRole = async ({ name, permissionCodes }) => {
  return axiosInstance.post("/roles", { name, permissionCodes });
};

export const updateRole = async (roleId, payload) => {
  return axiosInstance.patch(`/roles/${roleId}`, payload);
};

export const deleteRole = async (roleId) => {
  return axiosInstance.delete(`/roles/${roleId}`);
};

export const fetchRoleAssignments = async ({ loginId, projectId } = {}) => {
  return axiosInstance.get("/role-assignments", {
    params: { loginId, projectId },
  });
};

// Grant a role over ONE project or ONE society (v3_96) — the backend rejects a body naming both
// or neither. `societyId` used to be dropped on the floor here while the Team page's society
// picker was passing it, so every society assignment posted {loginId, rbacRoleId} and came back
// 400 "An assignment must name exactly one of projectId or societyId". Only the scope actually
// supplied is sent, so neither key is ever present as an explicit undefined.
export const createRoleAssignment = async ({ loginId, rbacRoleId, projectId, societyId }) => {
  return axiosInstance.post("/role-assignments", {
    loginId,
    rbacRoleId,
    ...(projectId != null ? { projectId } : {}),
    ...(societyId != null ? { societyId } : {}),
  });
};

// Same grant across many scopes in one call. Projects and societies can be mixed: the endpoint
// creates one assignment per id in each list, so a user ends up scoped to both.
export const createRoleAssignmentsBulk = async ({ loginId, rbacRoleId, projectIds, societyIds }) => {
  return axiosInstance.post("/role-assignments/bulk", {
    loginId,
    rbacRoleId,
    projectIds: projectIds || [],
    societyIds: societyIds || [],
  });
};

export const deleteRoleAssignment = async (assignmentId) => {
  return axiosInstance.delete(`/role-assignments/${assignmentId}`);
};
